import {
  Box,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";

const Overview = () => {
  const { id } = useParams();
  const theme = useTheme(); // Access theme

  const { data } = useQuery({
    queryKey: ["ADVISOR_DETAILS", id],
    queryFn: () => axiosInstance.get(`/super_admin/${id}/advisor/`),
    onError: () => {},
  });

  const [selectedRow, setSelectedRow] = useState(null);

  const metrics = [
    { label: "Admin User No.", value: data?.data?.client || "-" },
    { label: "Client Created", value: data?.data?.clients || "-" },
    { label: "Portfolio Created", value: data?.data?.portfolios || "-" },
    { label: "Total AUM", value: data?.data?.totalAum || "-" },
    { label: "Trades Imported", value: data?.data?.client || "-" },
    { label: "Basket Created", value: data?.data?.client || "-" },
    {
      label: "Model Portfolio Created",
      value: data?.data?.modelPortfolios || "-",
    },
    { label: "" },
    { label: "SC Portfolio Regis.", value: data?.data?.client || "-" },
    { label: "SC Portfolio Traded", value: data?.data?.client || "-" },
    { label: "SC Portfolio Trading", value: data?.data?.client || "-" },
    { label: "Total wallet Recharged", value: data?.data?.cashEntries || "-" },
  ];

  const complianceMetrics = [
    { key: "KYC", value: data?.data?.kycCount || "-" },
    { key: "Agreement", value: data?.data?.agreementCount || "-" },
    { key: "Risk Profile", value: data?.data?.riskProfileCount || "-" },
  ];

  const activityLog = [
    { particular: "Registered", date: data?.data?.createdOn || "-" },
    { particular: "Account approved", date: data?.data?.created || "-" },
    { particular: "Trial Started", date: data?.data?.created || "-" },
  ];

  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card
          sx={{
            padding: 2,
            boxShadow: 1,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography>
                Company Name: {data?.data?.companyName || "-"}
              </Typography>
              <Typography>Advisor: {data?.data?.name || "-"}</Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography>Mobile Number: {data?.data?.phone || "-"}</Typography>
              <Typography>Plan Type: {data?.data?.planType || "-"}</Typography>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card
          sx={{
            padding: 2,
            boxShadow: 1,
          }}
        >
          <Grid container spacing={2}>
            {metrics.map((metric, index) => (
              <Grid item xs={4} key={index}>
                <Box
                  sx={{
                    padding: 2,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body1" gutterBottom>
                    {metric.label}
                  </Typography>
                  <Typography variant="h6" color={theme.palette.primary.main}>
                    {metric.value}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card
          sx={{
            padding: 2,
            boxShadow: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Compliance
          </Typography>
          <TableContainer
            component={Paper}
            sx={{ width: "100%", marginTop: 2 }}
          >
            <Table aria-label="compliance metrics table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                    }}
                  >
                    Particulars
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                    }}
                  >
                    No. of times
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {complianceMetrics.map((metric, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      <Typography>{metric.key}</Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ color: theme.palette.primary.main }}
                    >
                      {metric.value}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card
          sx={{
            padding: 2,
            boxShadow: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Activity Log
          </Typography>
          <TableContainer
            component={Paper}
            sx={{ width: "100%", marginTop: 2 }}
          >
            <Table aria-label="activity log table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontSize: "1.1rem",
                    }}
                  >
                    Particulars
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: "1.1rem",
                    }}
                  >
                    Date
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activityLog.map((row, index) => (
                  <TableRow key={index} onClick={() => handleRowClick(row)}>
                    <TableCell component="th" scope="row">
                      <Typography>{row.particular}</Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ color: theme.palette.primary.main }}
                    >
                      {row.date}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>

      {selectedRow && (
        <Grid item xs={12}>
          <Card
            sx={{
              padding: 2,
              boxShadow: 2,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Selected Details
            </Typography>
            <Typography>
              Particular: {selectedRow.key || selectedRow.particular}
            </Typography>
            {selectedRow.date && (
              <Typography>Date: {selectedRow.date}</Typography>
            )}
            {selectedRow.value && (
              <Typography>Value: {selectedRow.value}</Typography>
            )}
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default Overview;
